require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-support-vector-machines.json") })
        }
      }, "path---posts-support-vector-machines");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-support-vector-machines!./.cache/json/posts-support-vector-machines.json
// module id = 411
// module chunks = 231608221292675